import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import { toast } from 'sonner';

// Handles the return from Emergent Google OAuth.
// The user lands at /admin/dashboard#session_id=XXXX — we exchange it for a
// server session cookie, then redirect to the dashboard.
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate('/admin');
        return;
      }
      try {
        await api.post('/auth/session', {}, { headers: { 'X-Session-ID': sessionId } });
        window.history.replaceState(null, '', '/admin/dashboard');
        toast.success('Connexion Google réussie');
        navigate('/admin/dashboard');
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Connexion Google refusée');
        window.history.replaceState(null, '', '/admin');
        navigate('/admin');
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#1C2033] flex items-center justify-center">
      <div className="text-center">
        <h1 className="font-serif text-[#F7F2EC] text-3xl">Le 8<sup className="text-[0.6em]">e</sup> Sens</h1>
        <p className="eyebrow mt-4 text-[#C3A572]">Connexion en cours…</p>
      </div>
    </div>
  );
}
